var userAgent = require('../internals/user-agent');

module.exports = /(iphone|ipod|ipad).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/internals/is-ios.js
// module id = CVla
// module chunks = 0